import { FieldMap } from '../../../types/forms/fields'
import { gynHistoryField, gynHistoryWithoutPregnanciesField } from './gynHistory'
import { immunizationsField } from './immunizations'
import { sexualBehaviorField } from './sexualBehavior'

export const gynAndSexualHistoryWithoutPregnanciesField: FieldMap = {
  name: 'GYN and Sexual History',
  children: {
    gynHistory: gynHistoryWithoutPregnanciesField,
    sexualBehavior: sexualBehaviorField,
    immunizations: immunizationsField,
  },
}

export const gynAndSexualHistoryField = {
  name: 'GYN History',
  children: {
    gynHistory: gynHistoryField,
    sexualBehavior: sexualBehaviorField,
    immunizations: immunizationsField,
  },
} as const
